<div [matTooltip]="tooltipText" [matTooltipDisabled]="!isDisabled">
    <!-- [att.color] is needed, so that our custom scss in button.scss works -->
    @switch (type) {
        @case ('flat') {
            <button
                [ngClass]="customClasses"
                mat-flat-button
                [color]="color"
                [attr.color]="color"
                [disabled]="isDisabled || isLoading"
                (click)="handleClick()"
                type="button">
                <ng-container *ngTemplateOutlet="contentTpl" />
            </button>
        }
        @case ('raised') {
            <button
                [ngClass]="customClasses"
                mat-raised-button
                [color]="color"
                [attr.color]="color"
                [disabled]="isDisabled || isLoading"
                (click)="handleClick()"
                type="button">
                <ng-container *ngTemplateOutlet="contentTpl" />
            </button>
        }
        @case ('stroked') {
            <button
                [ngClass]="customClasses"
                mat-stroked-button
                [color]="color"
                [attr.color]="color"
                [disabled]="isDisabled || isLoading"
                (click)="handleClick()"
                type="button">
                <ng-container *ngTemplateOutlet="contentTpl" />
            </button>
        }
        @case ('icon') {
            <button
                [ngClass]="customClasses"
                mat-icon-button
                [color]="color"
                [attr.color]="color"
                [disabled]="isDisabled || isLoading"
                (click)="handleClick()"
                [style]="isLoading ? '--mat-icon-button-icon-size: 16px !important' : ''"
                type="button">
                @if (isLoading) {
                    <div class="flex items-center">
                        <mat-spinner [diameter]="16" [color]="spinnerColor" />
                    </div>
                } @else {
                    <arc-icon [icon]="icon!" />
                }
            </button>
        }
        @default {
            <button
                [ngClass]="customClasses"
                mat-button
                [color]="color"
                [attr.color]="color"
                [disabled]="isDisabled || isLoading"
                (click)="handleClick()"
                type="button">
                <ng-container *ngTemplateOutlet="contentTpl" />
            </button>
        }
    }
</div>

<ng-template #contentTpl>
    <div class="flex items-center gap-2">
        @if (isLoading) {
            <mat-spinner [diameter]="16" [color]="spinnerColor" />
        } @else if (!!prefixIcon) {
            <mat-icon>{{ prefixIcon }}</mat-icon>
        }

        <span>
            @if (!title) {
                <ng-content />
            } @else {
                <div class="flex gap-2">
                    @if (!!icon) {
                        <arc-icon [icon]="icon" />
                    }
                    {{ title }}
                </div>
            }
        </span>
    </div>
</ng-template>
